import React from 'react';
import styled from 'styled-components';
import Checkbox from '@catalogo/theme-form-builder/src/components/checkbox';
import { LazyPicture } from '@catalogo/theme-lazy-picture';
import Rating from '@catalogo/ui-americanas-mobile-rating';
import { formatPrice } from '@catalogo/core-helpers/price';
import { getProductPathname } from '@catalogo/core-product/src/index';
import { IProductCard, IStyle } from '../helpers/interfaces';
import { onClick } from '../helpers/functions';

export const ProductCard: React.FC<IProductCard> = props => {
  const {
    image,
    name,
    salesPrice,
    sku,
    sellerId,
    isSelected,
    handleClick,
    id,
    slug,
    condition,
    rating,
    first,
    offer,
  } = props;

  const pathname = getProductPathname({ id, slug });
  const linkOfProduct = `${pathname}pfm_type=vit_recommendation&pfm_page=product&pfm_carac=compre_junto`;

  return (
    <Container first={first}>
      <CheckboxContainer>
        <Checkbox onClick={onClick(sku, sellerId, salesPrice, isSelected, id, condition, offer, handleClick)} />
      </CheckboxContainer>
      <ImageBox>
        <LazyPicture sources={{ desktop: { src: image } }} alt={`foto do ${name}`} />
      </ImageBox>
      <ProductInfo>
        <ProductName href={linkOfProduct} target="_blank">
          {name}
        </ProductName>
        <Rating rating={rating} size={13} fontSize={0} url="#" />
        <PriceUI>R$ {formatPrice(salesPrice)}</PriceUI>
      </ProductInfo>
    </Container>
  );
};

const Container = styled.div<IStyle>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${({ first }) => (first ? '17px' : '0px')};
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ImageBox = styled.div`
  min-width: 54px;
  width: 54px;
  height: 54px;
  margin: 0px 8px;
`;

const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const ProductName = styled.a`
  font-size: 14px;
  line-height: 16px;
  text-decoration-line: underline;
  color: ${({ theme }) => theme.grey.dark};
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const PriceUI = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.grey.darker};
`;

export default ProductCard;
